export default __webpack_public_path__ + "static/media/water-bottle.e1ba3f76.svg";